enum SubscriptionStatus {
  Trial = 'trial',
  Active = 'active',
  Cancelled = 'cancelled',
}

export default SubscriptionStatus;
